import { BREAKPOINT_ORDER } from '../constants/breakpoints';
import type { Breakpoint } from '../types/breakpoint';
import type { Responsive } from '../types/responsive';

// A type predicate narrows both branches, also in apps compiled without `strict` (web).
function isPerBreakpoint<T>(value: Responsive<T>): value is Partial<Record<Breakpoint, T>> {
    return typeof value === 'object' && value !== null;
}

/** A responsive value as `[breakpoint, value]` pairs, smallest breakpoint first; a scalar becomes `base`. */
export function toBreakpointEntries<T>(value: Responsive<T>): [Breakpoint, T | undefined][] {
    if (isPerBreakpoint(value)) {
        return BREAKPOINT_ORDER.map((breakpoint) => [breakpoint, value[breakpoint]]);
    }

    return [['base', value]];
}
